import { render, staticRenderFns } from "./SchoolSta.vue?vue&type=template&id=f9384496&scoped=true&"
import script from "./SchoolSta.vue?vue&type=script&lang=js&"
export * from "./SchoolSta.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSta.vue?vue&type=style&index=0&id=f9384496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9384496",
  null
  
)

export default component.exports